import {
    faAppleWhole,
    faArrowLeft,
    faBadgePercent,
    faBooks,
    faCartShopping,
    faCashRegister,
    faChevronLeft,
    faChevronRight,
    faCompass,
    faDoorOpen,
    faEarthAfrica,
    faFileContract,
    faFileLock,
    faHatChef,
    faLocationDot,
    faLock,
    faMap,
    faMobileScreenButton,
    faMoneyBill,
    faPen,
    faRectangleBarcode,
    faRightToBracket,
    faSearch,
    faTicket,
    faUnlock,
    faUser,
    faXmark,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { BrandIcons } from '@whiz-cart/node-shared/models/brand/brand';
import asDict from '@whiz-cart/node-shared/models/helpers/asDict';
import { vars } from '@whiz-cart/ui-shared/theme/vars';
import type { CSSProperties, ReactNode } from 'react';

export default asDict({
    search: ({ size, ...props }) => <FontAwesomeIcon fixedWidth icon={faSearch} fontSize={size} {...props} />,
    pluHierarchy: ({ size, ...props }) => <FontAwesomeIcon fixedWidth icon={faAppleWhole} fontSize={size} {...props} />,
    pluSearch: ({ size, ...props }) => <FontAwesomeIcon fixedWidth icon={faRectangleBarcode} fontSize={size} {...props} />,
    promotion: ({ size, ...props }) => <FontAwesomeIcon fixedWidth icon={faBadgePercent} fontSize={size} {...props} />,
    sosInactive: (props) => <SosIcon {...props} />,
    sosActive: (props) => <SosIcon active {...props} />,
    lockActive: ({ size, ...props }) => <FontAwesomeIcon fixedWidth icon={faLock} fontSize={size} {...props} />,
    lockInactive: ({ size, ...props }) => <FontAwesomeIcon fixedWidth icon={faUnlock} fontSize={size} {...props} />,
    cart: ({ size, ...props }) => <FontAwesomeIcon fixedWidth icon={faCartShopping} fontSize={size} {...props} />,
    cartPlus: ({ size, ...props }) => <FontAwesomeIcon fixedWidth icon={faCartShopping} fontSize={size} {...props} />,
    navigation: ({ size, ...props }) => <FontAwesomeIcon fixedWidth icon={faMap} fontSize={size} {...props} />,
    arrowLeftTutorial: ({ size, ...props }) => <FontAwesomeIcon fixedWidth icon={faChevronLeft} fontSize={size} {...props} />,
    arrowRightTutorial: ({ size, ...props }) => <FontAwesomeIcon fixedWidth icon={faChevronRight} fontSize={size} {...props} />,
    arrowBack: ({ size, ...props }) => <FontAwesomeIcon fixedWidth icon={faArrowLeft} fontSize={size} {...props} />,
    user: ({ size, ...props }) => <FontAwesomeIcon fixedWidth icon={faUser} fontSize={size} {...props} />,
    location: ({ size, ...props }) => <FontAwesomeIcon fixedWidth icon={faLocationDot} fontSize={size} {...props} />,
    edit: ({ size, ...props }) => <FontAwesomeIcon fixedWidth icon={faPen} fontSize={size} {...props} />,
    exit: ({ size, ...props }) => <FontAwesomeIcon fixedWidth icon={faDoorOpen} fontSize={size} {...props} />,
    exitPopUp: ({ size, ...props }) => <FontAwesomeIcon fixedWidth icon={faDoorOpen} fontSize={size} {...props} />,
    startShopping: ({ size, ...props }) => <FontAwesomeIcon fixedWidth icon={faRightToBracket} fontSize={size} {...props} />,
    startPayment: ({ size, ...props }) => <FontAwesomeIcon fixedWidth icon={faMoneyBill} fontSize={size} {...props} />,
    checkout: ({ size, ...props }) => <FontAwesomeIcon fixedWidth icon={faCashRegister} fontSize={size} {...props} />,
    payByApp: ({ size, ...props }) => <FontAwesomeIcon fixedWidth icon={faMobileScreenButton} fontSize={size} {...props} />,
    payAtRegister: ({ size, ...props }) => <FontAwesomeIcon fixedWidth icon={faCashRegister} fontSize={size} {...props} />,
    navigate: ({ size, ...props }) => <FontAwesomeIcon fixedWidth icon={faCompass} fontSize={size} {...props} />,
    recipes: ({ size, ...props }) => <FontAwesomeIcon fixedWidth icon={faHatChef} fontSize={size} {...props} />,
    language: ({ size, ...props }) => <FontAwesomeIcon fixedWidth icon={faEarthAfrica} fontSize={size} {...props} />,
    close: ({ size, ...props }) => <FontAwesomeIcon fixedWidth icon={faXmark} fontSize={size} {...props} />,
    tutorial: ({ size, ...props }) => <FontAwesomeIcon fixedWidth icon={faBooks} fontSize={size} {...props} />,
    dataPrivacy: ({ size, ...props }) => <FontAwesomeIcon fixedWidth icon={faFileLock} fontSize={size} {...props} />,
    termsAndConditions: ({ size, ...props }) => <FontAwesomeIcon fixedWidth icon={faFileContract} fontSize={size} {...props} />,
    coupon: ({ size, ...props }) => <FontAwesomeIcon fixedWidth icon={faTicket} fontSize={size} {...props} />,
} satisfies Partial<Record<keyof BrandIcons, (props: { size: number | string; className?: string; style?: CSSProperties }) => ReactNode>>);

function SosIcon({ size, active }: { size: number | string; active?: boolean }) {
    return (
        <div
            css={[
                {
                    position: 'relative',
                    fontSize: size,
                    width: '1em',
                    height: '1em',
                    fontWeight: 'bold',
                    backgroundColor: vars.cartBackgroundContrastText,
                    color: vars.cartBackgroundMain,
                    borderRadius: '50%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1,
                },
                active && {
                    backgroundColor: 'var(--warningColor)',
                    color: 'var(--lightColor)',

                    '&:before': {
                        content: '""',
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'var(--warningColor)',
                        borderRadius: '50%',
                        zIndex: -1,
                        '@keyframes pulse': {
                            '100%': {
                                transform: 'scale(2)',
                                opacity: 0,
                            },
                        },
                        animationName: 'pulse',
                        animationDuration: '1s',
                        animationIterationCount: 'infinite',
                    },
                },
            ]}
        >
            ?
        </div>
    );
}
